import { render } from "./PrefeituraDashboard.vue?vue&type=template&id=3d52f5fd&scoped=true"
import script from "./PrefeituraDashboard.vue?vue&type=script&lang=js"
export * from "./PrefeituraDashboard.vue?vue&type=script&lang=js"

import "./PrefeituraDashboard.vue?vue&type=style&index=0&id=3d52f5fd&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d52f5fd"]])

export default __exports__